import type { IQBLinkageHandler } from '../types';
import { hasNonEmptyArrayInLayers, patchBoth } from './shared';

export const referenceLineHandler: IQBLinkageHandler = {
  id: 'referenceLine',
  phase: 'prune',
  keys: ['reference_line'],
  subscribe: ['metricRemoved'],
  apply(changeSet, ctx) {
    if (!hasNonEmptyArrayInLayers(ctx.base, ctx.draft, 'reference_line')) {
      return;
    }
    const removed = new Set(
      changeSet.removedMetrics.map((m) => m.column_name),
    );
    const baseLines = ctx.base.reference_line;
    const draftLines = ctx.draft.reference_line;
    const baseFiltered = Array.isArray(baseLines)
      ? baseLines.filter((row: Record<string, unknown>) => {
          const metric = String(row.metric ?? row.column_name ?? '');
          return !removed.has(metric);
        })
      : undefined;
    const draftFiltered = Array.isArray(draftLines)
      ? draftLines.filter((row: Record<string, unknown>) => {
          const metric = String(row.metric ?? row.column_name ?? '');
          return !removed.has(metric);
        })
      : undefined;
    const baseChanged =
      Array.isArray(baseLines) &&
      Array.isArray(baseFiltered) &&
      baseFiltered.length !== baseLines.length;
    const draftChanged =
      Array.isArray(draftLines) &&
      Array.isArray(draftFiltered) &&
      draftFiltered.length !== draftLines.length;
    if (!baseChanged && !draftChanged) {
      return;
    }
    return patchBoth(
      baseChanged ? { reference_line: baseFiltered } : undefined,
      draftChanged ? { reference_line: draftFiltered } : undefined,
    );
  },
};
